<div class="select-container d-flex">
    <label class="my-auto">Theme</label>
    <select class="form-control" [ngModel]="svc.selected" (ngModelChange)="themeChange($event)">
        <option *ngFor="let item of svc.themes" [ngValue]="item">{{item.label}}</option>
    </select>
</div>